import * as Yup from 'yup';

export const schema = Yup.object().shape({
  description: Yup.string().required('Descrição é obrigatória'),
  supplier: Yup.string().required('Fornecedor é obrigatório'),
  category: Yup.string(),
  value: Yup.number()
    .required('Valor é obrigatório')
    .min(0.01, 'Valor deve ser maior que zero'),
  dueDate: Yup.date().required('Data de vencimento é obrigatória'),
  paymentDate: Yup.date(),
  status: Yup.string().required('Status é obrigatório'),
  notes: Yup.string(),
});

